import React from "react";

const ChangeLog = () => {
     return (
          <div className="container mt-5 text-center fw-bold alert-dark p-5">
               This Displays Changes that Happen to Client so we can track if there is things changed.
          </div>
     )
}

export default ChangeLog;